import { takeLatest, put, call, fork, select } from 'redux-saga/effects';
import callApi from 'utils/api';
import { getReferenceData } from 'common/reference-data/containers/reference-data-actions';
import * as actionTypes from './constants';

import {
  notificationInfoSuccess,
  notificationInfoFailure,
  callInfoSuccess,
  callInfoFailure,
} from './notification_call-actions';

export const getServiceCenterId = state => state.navigation.navigationSelf.serviceCenterId;
export const getPartnerTypes = state =>
  state.referenceData.data[`${getServiceCenterId}_order_partnerTypes`];

export function* doFetchNotificationInfo(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `info/notification/${action.payload.notificationId}`,
      options: {
        errorMessage: `Could not get info for notification ${action.payload.notificationId}`,
        retryAction: action,
      },
    });

    const serviceCenterId = yield select(getServiceCenterId);
    yield put(
      getReferenceData({
        objectType: 'order',
        name: 'partnerTypes',
        urlParams: '',
        serviceCenterId,
      }),
    );

    yield put(notificationInfoSuccess(results));
  } catch (err) {
    yield put(notificationInfoFailure(err));
  }
}

export function* doFetchCallInfo(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `info/call/${action.payload.callId}`,
      options: {
        errorMessage: `Could not get info for call ${action.payload.callId}`,
        retryAction: action,
      },
    });

    const partnerTypes = yield select(getPartnerTypes);
    if (!partnerTypes) {
      const serviceCenterId = yield select(getServiceCenterId);
      yield put(
        getReferenceData({
          objectType: 'order',
          name: 'partnerTypes',
          urlParams: '',
          serviceCenterId,
        }),
      );
    }

    yield put(callInfoSuccess(results));
  } catch (err) {
    yield put(callInfoFailure(err));
  }
}

function* watchFetchNotificationInfo() {
  yield takeLatest(actionTypes.NOTIFICATION_INFO_REQUEST, doFetchNotificationInfo);
}

function* watchFetchCallInfo() {
  yield takeLatest(actionTypes.CALL_INFO_REQUEST, doFetchCallInfo);
}

export default [fork(watchFetchNotificationInfo), fork(watchFetchCallInfo)];
